module.exports = __webpack_public_path__ + "static/img/zhudongjunheng.73c81f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhudongjunheng.jpg
// module id = e9zT
// module chunks = 1